import { useMutation } from "@tanstack/react-query";
import { setGoPaperless } from "api/set-go-paperless";

export const useSetGoPaperless = () =>
  useMutation({ mutationFn: setGoPaperless });
